// Ring Sizer Modal JavaScript
// Extracted from main-product.liquid for better organization

// Ring Sizer script loaded

// Fonction pour créer et ouvrir la modale de baguier
function openRingSizerModal(blockId) {
  // Ouverture modale baguier pour bloc
  
  // Récupérer les données configurables
  const dataElement = document.getElementById('ring-sizer-data-' + blockId);
  // Element de données trouvé
  let config = {
    modal_title: "",
    modal_description: "",
    modal_subtitle: "",
    button_text: "",
    button_bg_color: "#333",
    button_text_color: "#ffffff",
    success_message: ""
  };
  
  if (dataElement) {
    // Attributs data trouvés
    
    // Détecter la langue
    const isEnglish = window.location.pathname.includes('/en/') || window.location.pathname.includes('/en-') || window.location.pathname === '/en';
    
    config = {
      modal_title: isEnglish ? 
        (dataElement.getAttribute('data-modal-title-en') || dataElement.getAttribute('data-modal-title')) :
        dataElement.getAttribute('data-modal-title'),
      modal_description: isEnglish ?
        (dataElement.getAttribute('data-modal-description-html-en') || dataElement.getAttribute('data-modal-description-html')) :
        dataElement.getAttribute('data-modal-description-html'),
      modal_subtitle: isEnglish ?
        (dataElement.getAttribute('data-modal-subtitle-en') || dataElement.getAttribute('data-modal-subtitle')) :
        dataElement.getAttribute('data-modal-subtitle'),
      button_text: isEnglish ?
        (dataElement.getAttribute('data-button-text-en') || dataElement.getAttribute('data-button-text')) :
        dataElement.getAttribute('data-button-text'),
      button_bg_color: dataElement.getAttribute('data-button-bg-color') || config.button_bg_color,
      button_text_color: dataElement.getAttribute('data-button-text-color') || config.button_text_color,
      success_message: isEnglish ?
        (dataElement.getAttribute('data-success-message-en') || dataElement.getAttribute('data-success-message')) :
        dataElement.getAttribute('data-success-message'),
      title_size_desktop: dataElement.getAttribute('data-title-size-desktop') || '20',
      title_size_mobile: dataElement.getAttribute('data-title-size-mobile') || '18',
      // Traductions des champs avec détection de langue
      label_nom: isEnglish ?
        (dataElement.getAttribute('data-label-nom-en') || dataElement.getAttribute('data-label-nom')) :
        dataElement.getAttribute('data-label-nom'),
      placeholder_nom: isEnglish ?
        (dataElement.getAttribute('data-placeholder-nom-en') || dataElement.getAttribute('data-placeholder-nom')) :
        dataElement.getAttribute('data-placeholder-nom'),
      label_prenom: isEnglish ?
        (dataElement.getAttribute('data-label-prenom-en') || dataElement.getAttribute('data-label-prenom')) :
        dataElement.getAttribute('data-label-prenom'),
      placeholder_prenom: isEnglish ?
        (dataElement.getAttribute('data-placeholder-prenom-en') || dataElement.getAttribute('data-placeholder-prenom')) :
        dataElement.getAttribute('data-placeholder-prenom'),
      label_adresse: isEnglish ?
        (dataElement.getAttribute('data-label-adresse-en') || dataElement.getAttribute('data-label-adresse')) :
        dataElement.getAttribute('data-label-adresse'),
      placeholder_adresse: isEnglish ?
        (dataElement.getAttribute('data-placeholder-adresse-en') || dataElement.getAttribute('data-placeholder-adresse')) :
        dataElement.getAttribute('data-placeholder-adresse'),
      label_code_postal: isEnglish ?
        (dataElement.getAttribute('data-label-code-postal-en') || dataElement.getAttribute('data-label-code-postal')) :
        dataElement.getAttribute('data-label-code-postal'),
      placeholder_code_postal: isEnglish ?
        (dataElement.getAttribute('data-placeholder-code-postal-en') || dataElement.getAttribute('data-placeholder-code-postal')) :
        dataElement.getAttribute('data-placeholder-code-postal'),
      label_ville: isEnglish ?
        (dataElement.getAttribute('data-label-ville-en') || dataElement.getAttribute('data-label-ville')) :
        dataElement.getAttribute('data-label-ville'),
      placeholder_ville: isEnglish ?
        (dataElement.getAttribute('data-placeholder-ville-en') || dataElement.getAttribute('data-placeholder-ville')) :
        dataElement.getAttribute('data-placeholder-ville'),
      label_pays: isEnglish ?
        (dataElement.getAttribute('data-label-pays-en') || dataElement.getAttribute('data-label-pays')) :
        dataElement.getAttribute('data-label-pays'),
      placeholder_pays: isEnglish ?
        (dataElement.getAttribute('data-placeholder-pays-en') || dataElement.getAttribute('data-placeholder-pays')) :
        dataElement.getAttribute('data-placeholder-pays'),
      label_email: isEnglish ?
        (dataElement.getAttribute('data-label-email-en') || dataElement.getAttribute('data-label-email')) :
        dataElement.getAttribute('data-label-email'),
      placeholder_email: isEnglish ?
        (dataElement.getAttribute('data-placeholder-email-en') || dataElement.getAttribute('data-placeholder-email')) :
        dataElement.getAttribute('data-placeholder-email'),
      label_telephone: isEnglish ?
        (dataElement.getAttribute('data-label-telephone-en') || dataElement.getAttribute('data-label-telephone')) :
        dataElement.getAttribute('data-label-telephone'),
      placeholder_telephone: isEnglish ?
        (dataElement.getAttribute('data-placeholder-telephone-en') || dataElement.getAttribute('data-placeholder-telephone')) :
        dataElement.getAttribute('data-placeholder-telephone'),
      label_civilite: isEnglish ?
        (dataElement.getAttribute('data-label-civilite-en') || dataElement.getAttribute('data-label-civilite') || 'TITLE *') :
        (dataElement.getAttribute('data-label-civilite') || 'CIVILITÉ *'),
      option_mme: isEnglish ?
        (dataElement.getAttribute('data-option-mme-en') || dataElement.getAttribute('data-option-mme') || 'Ms.') :
        (dataElement.getAttribute('data-option-mme') || 'Mme'),
      option_m: isEnglish ?
        (dataElement.getAttribute('data-option-m-en') || dataElement.getAttribute('data-option-m') || 'Mr.') :
        (dataElement.getAttribute('data-option-m') || 'M.'),
      option_mx: isEnglish ?
        (dataElement.getAttribute('data-option-mx-en') || dataElement.getAttribute('data-option-mx') || 'Mx.') :
        (dataElement.getAttribute('data-option-mx') || 'Mx.'),
      label_complement_adresse: isEnglish ?
        (dataElement.getAttribute('data-label-complement-adresse-en') || dataElement.getAttribute('data-label-complement-adresse')) :
        dataElement.getAttribute('data-label-complement-adresse'),
      placeholder_complement_adresse: isEnglish ?
        (dataElement.getAttribute('data-placeholder-complement-adresse-en') || dataElement.getAttribute('data-placeholder-complement-adresse')) :
        dataElement.getAttribute('data-placeholder-complement-adresse')
    };
  }

  // Supprimer la modale existante si elle existe
  const existingModal = document.getElementById('ring-sizer-modal');
  if (existingModal) {
    existingModal.remove();
  }

  // Générer un ID unique pour le titre
  const uniqueId = 'modal-title-' + blockId + '-' + Date.now();
  
  // Créer la modale dynamiquement
  const modal = document.createElement('div');
  modal.id = 'ring-sizer-modal';
  modal.innerHTML = `
    <div class="ring-sizer-modal-backdrop" style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(0,0,0,0.7); z-index: 99999; display: flex; align-items: center; justify-content: center; padding: 20px;">
      <div class="ring-sizer-modal-content" style="background: white; width: 90%; max-width: 600px; max-height: 80vh; overflow-y: auto; position: relative; box-shadow: 0 4px 20px rgba(0,0,0,0.3);">
        <div style="position: relative; padding: 30px; border-bottom: 1px solid #e8e8e8;">
          <button onclick="closeRingSizerModal()" style="position: absolute; top: 15px; right: 15px; background: none; border: none; font-size: 24px; cursor: pointer; color: #666; padding: 0; width: 30px; height: 30px;">&times;</button>
          <h2 id="${uniqueId}" class="modal-title-responsive" style="font-family: 'Oswald', sans-serif !important; font-size: ${config.title_size_desktop}px !important; font-weight: normal; margin: 0; letter-spacing: 1px; text-align: center; text-transform: uppercase; padding-top: 30px;">${config.modal_title}</h2>
        </div>
        
        <style>
          @media (max-width: 768px) {
            #${uniqueId} {
              font-size: ${config.title_size_mobile}px !important;
            }
          }
        </style>
        <div style="padding: 30px;">
          <div id="modal-description-content" style="margin-bottom: 15px; line-height: 1.6; color: #333; text-align: center;">
          </div>
          ${config.modal_subtitle ? `<p style="margin-bottom: 30px; font-weight: 500; color: #333; text-align: center;">
            ${config.modal_subtitle}
          </p>` : ''}
          
          <form id="ring-sizer-form" style="display: flex; flex-direction: column; gap: 20px;">
            <!-- Options de civilité -->
            <div style="display: flex; flex-direction: column;">
              <label style="margin-bottom: 6px; font-weight: 500; color: #333; font-size: 14px; text-transform: uppercase; font-family: 'Oswald', sans-serif;">${config.label_civilite}</label>
              <div style="display: flex; gap: 20px;">
                <label style="display: flex; align-items: center; gap: 8px; cursor: pointer;">
                  <input type="radio" name="civilite" value="Mme" required style="margin: 0;">
                  <span style="font-size: 14px;">${config.option_mme}</span>
                </label>
                <label style="display: flex; align-items: center; gap: 8px; cursor: pointer;">
                  <input type="radio" name="civilite" value="M." required style="margin: 0;">
                  <span style="font-size: 14px;">${config.option_m}</span>
                </label>
                <label style="display: flex; align-items: center; gap: 8px; cursor: pointer;">
                  <input type="radio" name="civilite" value="Mx" required style="margin: 0;">
                  <span style="font-size: 14px;">${config.option_mx}</span>
                </label>
              </div>
            </div>
            
            <!-- Nom -->
            <div style="display: flex; flex-direction: column;">
              <label style="margin-bottom: 4px; font-weight: 500; color: #333; font-size: 14px; text-transform: uppercase; font-family: 'Oswald', sans-serif;">${config.label_nom}</label>
              <input type="text" name="nom" required style="width: 100%; padding: 0 0 12px 0; border: none; border-bottom: 1px solid #ddd; font-size: 14px; box-sizing: border-box; background: transparent; outline: none;" placeholder="${config.placeholder_nom}">
            </div>
            
            <!-- Prénom -->
            <div style="display: flex; flex-direction: column;">
              <label style="margin-bottom: 4px; font-weight: 500; color: #333; font-size: 14px; text-transform: uppercase; font-family: 'Oswald', sans-serif;">${config.label_prenom}</label>
              <input type="text" name="prenom" required style="width: 100%; padding: 0 0 12px 0; border: none; border-bottom: 1px solid #ddd; font-size: 14px; box-sizing: border-box; background: transparent; outline: none;" placeholder="${config.placeholder_prenom}">
            </div>
            
            <!-- Adresse -->
            <div style="display: flex; flex-direction: column;">
              <label style="margin-bottom: 4px; font-weight: 500; color: #333; font-size: 14px; text-transform: uppercase; font-family: 'Oswald', sans-serif;">${config.label_adresse}</label>
              <input type="text" name="adresse" required style="width: 100%; padding: 0 0 12px 0; border: none; border-bottom: 1px solid #ddd; font-size: 14px; box-sizing: border-box; background: transparent; outline: none;" placeholder="${config.placeholder_adresse}">
            </div>
            
            <!-- Complément d'adresse -->
            <div style="display: flex; flex-direction: column;">
              <label style="margin-bottom: 4px; font-weight: 500; color: #333; font-size: 14px; text-transform: uppercase; font-family: 'Oswald', sans-serif;">${config.label_complement_adresse}</label>
              <input type="text" name="complement_adresse" style="width: 100%; padding: 0 0 12px 0; border: none; border-bottom: 1px solid #ddd; font-size: 14px; box-sizing: border-box; background: transparent; outline: none;" placeholder="${config.placeholder_complement_adresse}">
            </div>
            
            <!-- Code postal -->
            <div style="display: flex; flex-direction: column;">
              <label style="margin-bottom: 4px; font-weight: 500; color: #333; font-size: 14px; text-transform: uppercase; font-family: 'Oswald', sans-serif;">${config.label_code_postal}</label>
              <input type="text" name="code_postal" required style="width: 100%; padding: 0 0 12px 0; border: none; border-bottom: 1px solid #ddd; font-size: 14px; box-sizing: border-box; background: transparent; outline: none;" placeholder="${config.placeholder_code_postal}">
            </div>
            
            <!-- Ville -->
            <div style="display: flex; flex-direction: column;">
              <label style="margin-bottom: 4px; font-weight: 500; color: #333; font-size: 14px; text-transform: uppercase; font-family: 'Oswald', sans-serif;">${config.label_ville}</label>
              <input type="text" name="ville" required style="width: 100%; padding: 0 0 12px 0; border: none; border-bottom: 1px solid #ddd; font-size: 14px; box-sizing: border-box; background: transparent; outline: none;" placeholder="${config.placeholder_ville}">
            </div>
            
            <!-- Pays -->
            <div style="display: flex; flex-direction: column;">
              <label style="margin-bottom: 4px; font-weight: 500; color: #333; font-size: 14px; text-transform: uppercase; font-family: 'Oswald', sans-serif;">${config.label_pays}</label>
              <input type="text" name="pays" required style="width: 100%; padding: 0 0 12px 0; border: none; border-bottom: 1px solid #ddd; font-size: 14px; box-sizing: border-box; background: transparent; outline: none;" placeholder="${config.placeholder_pays}">
            </div>
            
            <!-- Email -->
            <div style="display: flex; flex-direction: column;">
              <label style="margin-bottom: 4px; font-weight: 500; color: #333; font-size: 14px; text-transform: uppercase; font-family: 'Oswald', sans-serif;">${config.label_email}</label>
              <input type="email" name="email" required style="width: 100%; padding: 0 0 12px 0; border: none; border-bottom: 1px solid #ddd; font-size: 14px; box-sizing: border-box; background: transparent; outline: none;" placeholder="${config.placeholder_email}">
            </div>
            
            <!-- Téléphone -->
            <div style="display: flex; flex-direction: column;">
              <label style="margin-bottom: 4px; font-weight: 500; color: #333; font-size: 14px; text-transform: uppercase; font-family: 'Oswald', sans-serif;">${config.label_telephone}</label>
              <input type="tel" name="telephone" style="width: 100%; padding: 0 0 12px 0; border: none; border-bottom: 1px solid #ddd; font-size: 14px; box-sizing: border-box; background: transparent; outline: none;" placeholder="${config.placeholder_telephone}">
            </div>
            
            <!-- Texte politique de confidentialité -->
            <div id="privacy-policy-content" style="margin: 10px 0;">
            </div>
            
            <button type="submit" style="background: ${config.button_bg_color}; color: ${config.button_text_color}; border: none; padding: 15px 40px; font-size: 14px; font-weight: bold; letter-spacing: 1px; cursor: pointer; align-self: center; margin-top: 20px; font-family: 'Oswald', sans-serif !important; text-transform: uppercase;">${config.button_text}</button>
          </form>
        </div>
      </div>
    </div>
    
    <style>
      @media (max-width: 768px) {
        .address-fields-row {
          flex-direction: column !important;
          gap: 20px !important;
        }
        .address-fields-row > div {
          flex: none !important;
          width: 100% !important;
        }
      }
    </style>
  `;

  // Ajouter la modale au body
  document.body.appendChild(modal);
  document.body.style.overflow = 'hidden';

  const backdrop = modal.querySelector('.ring-sizer-modal-backdrop');
  if (backdrop) {
    backdrop.addEventListener('click', function(e) {
      if (e.target === backdrop) {
        closeRingSizerModal();
      }
    });
  }
  
  // Remplir le contenu rich text de la description
  const descriptionElement = document.getElementById('modal-description-content');
  if (descriptionElement) {
    descriptionElement.innerHTML = config.modal_description;
  }
  
  // Remplir le contenu de la politique de confidentialité avec les champs séparés
  const privacyElement = document.getElementById('privacy-policy-content');
  if (privacyElement) {
    // Détecter la langue
    const isEnglish = window.location.pathname.includes('/en/') || window.location.pathname.includes('/en-') || window.location.pathname === '/en';
    // Langue détectée
    
    // Récupérer les composants du texte
    const textBefore = isEnglish ? 
      (dataElement ? (dataElement.getAttribute('data-privacy-text-before-en') || dataElement.getAttribute('data-privacy-text-before') || 'By confirming, I accept the') : 'By confirming, I accept the') :
      (dataElement ? (dataElement.getAttribute('data-privacy-text-before') || 'En confirmant, j\'accepte la') : 'En confirmant, j\'accepte la');
    
    const linkText = isEnglish ? 
      (dataElement ? (dataElement.getAttribute('data-privacy-link-text-en') || dataElement.getAttribute('data-privacy-link-text') || 'privacy policy') : 'privacy policy') :
      (dataElement ? (dataElement.getAttribute('data-privacy-link-text') || 'politique de confidentialité') : 'politique de confidentialité');
    
    const linkUrl = isEnglish ? 
      (dataElement ? (dataElement.getAttribute('data-privacy-link-url-en') || dataElement.getAttribute('data-privacy-link-page-en') || dataElement.getAttribute('data-privacy-link-url') || dataElement.getAttribute('data-privacy-link-page') || '/pages/mentions-legales') : '/pages/mentions-legales') :
      (dataElement ? (dataElement.getAttribute('data-privacy-link-url') || dataElement.getAttribute('data-privacy-link-page') || '/pages/mentions-legales') : '/pages/mentions-legales');
    
    const textAfter = isEnglish ? 
      (dataElement ? dataElement.getAttribute('data-privacy-text-after-en') || dataElement.getAttribute('data-privacy-text-after') : '') :
      (dataElement ? dataElement.getAttribute('data-privacy-text-after') : '');
    
    // Valeurs récupérées
    
      // Construire le HTML en concaténant les champs disponibles
      let finalText = '';
      if (textBefore && textBefore.trim() !== '' && textBefore !== 'null') {
        finalText += textBefore + ' ';
      }
        if (linkText && linkText.trim() !== '' && linkText !== 'null') {
          // Normalize bare handles to absolute page paths (avoids /blogs/news/mentions-legales)
          let resolvedUrl = linkUrl && linkUrl.trim() !== '' && linkUrl !== 'null' ? linkUrl.trim() : '/pages/mentions-legales';
          if (resolvedUrl && !resolvedUrl.startsWith('/') && !resolvedUrl.startsWith('http')) {
            resolvedUrl = '/pages/' + resolvedUrl.replace(/^pages\//, '');
          }
          finalText += `<a href="${resolvedUrl}" target="_blank" class="product-option-link" style="text-decoration: underline !important; color: #333 !important; text-decoration-color: #333;">${linkText}</a> `;
        }
      if (textAfter && textAfter.trim() !== '' && textAfter !== 'null') {
        finalText += textAfter;
      }
      
      if (finalText.trim() !== '') {
        const finalHtml = `<p style="font-size: 14px; color: #666; margin: 0; line-height: 1.4; font-style: italic;">${finalText}</p>`;
        privacyElement.innerHTML = finalHtml;
      } else {
        privacyElement.style.display = 'none';
      }
  } else {
    // Element privacy-policy-content non trouvé
  }
  
  // Modal created and added to body
  
  // Ajouter l'event listener pour le formulaire
  const ringSizerForm = document.getElementById('ring-sizer-form');
  if (ringSizerForm) {
    ringSizerForm.addEventListener('submit', async function(e) {
      e.preventDefault();
      
      // Récupérer les données du formulaire
      const formData = new FormData(e.target);
      
      // Créer l'objet data avec les métadonnées de base
      const data = {
        "type": "baguier",
        "date_demande": new Date().toLocaleDateString('fr-FR'),
        "timestamp": new Date().toISOString(),
        "shop": window.Shopify?.shop || "loyale.myshopify.com",
        "product_name": document.querySelector('h1')?.textContent || "Produit",
        "product_url": window.location.href,
        "product_id": window.Shopify?.product?.id || '',
        "product_handle": window.Shopify?.product?.handle || '',
        "product_type": window.Shopify?.product?.type || '',
        "product_vendor": window.Shopify?.product?.vendor || '',
        "product_price": window.Shopify?.product?.price || '',
        "product_compare_price": window.Shopify?.product?.compare_at_price || '',
        "product_available": window.Shopify?.product?.available || '',
        "product_tags": window.Shopify?.product?.tags || '',
        
        // Informations de navigation
        "user_agent": navigator.userAgent,
        "referrer": document.referrer,
        "page_url": window.location.href,
        "page_title": document.title,
        "locale": window.Shopify?.locale || navigator.language,
        "language": navigator.language,
        "languages": navigator.languages ? navigator.languages.join(', ') : '',
        
        // Informations de session
        "session_id": window.Shopify?.cart?.token || '',
        "customer_id": window.Shopify?.customer?.id || '',
        "customer_email": window.Shopify?.customer?.email || '',
        "customer_orders_count": window.Shopify?.customer?.orders_count || '',
        "customer_total_spent": window.Shopify?.customer?.total_spent || '',
        
        // Informations de la boutique
        "shop_name": window.Shopify?.shop_name || '',
        "shop_domain": window.Shopify?.shop_domain || '',
        "shop_currency": window.Shopify?.currency?.active || '',
        "shop_locale": window.Shopify?.locale || '',
        
        // Informations d'écran
        "screen_width": screen.width,
        "screen_height": screen.height,
        "window_width": window.innerWidth,
        "window_height": window.innerHeight,
        "device_pixel_ratio": window.devicePixelRatio || 1,
        
        // Informations de géolocalisation
        "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
        "timezone_offset": new Date().getTimezoneOffset(),
        
        // Informations de l'heure
        "heure_demande": new Date().toLocaleTimeString('fr-FR')
      };
      
      // Ajouter automatiquement TOUS les champs du formulaire
      for (const [key, value] of formData.entries()) {
        data[key] = value || '';
      }
      
      // Envoi des données
      
      try {
        // Créer un FormData au lieu de JSON
        const formData = new FormData();
        Object.keys(data).forEach(key => {
          formData.append(key, data[key]);
        });
        
        const response = await fetch('https://loyale-proxy-make-baguier.old-shape-eb48.workers.dev/', {
          method: 'POST',
          body: formData
        });
        
        // Réponse reçue
        
        if (response.ok) {
          // Fermer la modale et afficher la confirmation
          closeRingSizerModal();
          
          // Récupérer les paramètres du bloc depuis l'élément de données
          // Chercher d'abord dans les éléments ring-sizer-data (pour multiple-buttons)
          let dataElement = document.querySelector('[id^="ring-sizer-data-"]');
          let blockSettings = {};
          
          if (dataElement) {
            // Détecter la langue
            const isEnglish = window.location.pathname.includes('/en/') || window.location.pathname.includes('/en-') || window.location.pathname === '/en';
            
            blockSettings = {
              confirmation_title: isEnglish ? 
                (dataElement.getAttribute('data-confirmation-title-en') || dataElement.getAttribute('data-confirmation-title') || 'THANK YOU {civility} {lastname}') :
                (dataElement.getAttribute('data-confirmation-title') || 'MERCI {civility} {lastname}'),
              confirmation_message: isEnglish ?
                (dataElement.getAttribute('data-confirmation-message-html-en') || dataElement.getAttribute('data-confirmation-message-html') || dataElement.getAttribute('data-confirmation-message') || 'Your free ring sizer request has been taken into account.') :
                (dataElement.getAttribute('data-confirmation-message-html') || dataElement.getAttribute('data-confirmation-message') || 'Votre demande de baguier gratuit a bien été prise en compte.'),
              confirmation_delivery_info: isEnglish ?
                (dataElement.getAttribute('data-confirmation-delivery-info-html-en') || dataElement.getAttribute('data-confirmation-delivery-info-html') || dataElement.getAttribute('data-confirmation-delivery-info') || '') :
                (dataElement.getAttribute('data-confirmation-delivery-info-html') || dataElement.getAttribute('data-confirmation-delivery-info') || ''),
              confirmation_email_info: isEnglish ?
                (dataElement.getAttribute('data-confirmation-email-info-html-en') || dataElement.getAttribute('data-confirmation-email-info-html') || dataElement.getAttribute('data-confirmation-email-info') || '') :
                (dataElement.getAttribute('data-confirmation-email-info-html') || dataElement.getAttribute('data-confirmation-email-info') || ''),
              confirmation_close_button: isEnglish ?
                (dataElement.getAttribute('data-confirmation-close-button-en') || dataElement.getAttribute('data-confirmation-close-button') || 'CLOSE') :
                (dataElement.getAttribute('data-confirmation-close-button') || 'FERMER'),
              button_bg_color: dataElement.getAttribute('data-button-bg-color') || '#000000',
              button_text_color: dataElement.getAttribute('data-button-text-color') || 'white'
            };
          } else {
            // Fallback pour les autres sections
            dataElement = document.querySelector('[data-block-id]');
            if (dataElement) {
              blockSettings = {
                confirmation_title: dataElement.getAttribute('data-confirmation-title') || 'MERCI {civility} {lastname}',
                confirmation_message: dataElement.getAttribute('data-confirmation-message-html') || 'Votre demande de baguier gratuit a bien été prise en compte.',
                confirmation_delivery_info: dataElement.getAttribute('data-confirmation-delivery-info-html') || '',
                confirmation_email_info: dataElement.getAttribute('data-confirmation-email-info-html') || '',
                confirmation_close_button: dataElement.getAttribute('data-confirmation-close-button') || 'FERMER',
                button_bg_color: dataElement.getAttribute('data-button-bg-color') || '#000000',
                button_text_color: dataElement.getAttribute('data-button-text-color') || 'white'
              };
            }
          }
          
          showConfirmationPage(data.civilite, data.nom, data.prenom, blockSettings);
        } else {
          // Erreur réponse
          alert('Erreur lors de l\'envoi du formulaire. Veuillez réessayer.');
        }
      } catch (error) {
        // Erreur réseau
        alert('Erreur de connexion. Veuillez vérifier votre connexion internet.');
      }
    });
  }
}

// Fonction pour fermer la modale de baguier
function closeRingSizerModal() {
  const modal = document.getElementById('ring-sizer-modal');
  if (modal) {
    modal.remove();
    document.body.style.overflow = 'auto';
    // Modal closed and removed
  }
}

// Fonction pour afficher la page de confirmation
function showConfirmationPage(civilite, nom, prenom, blockSettings) {
  // Supprimer la modale existante
  const existingModal = document.getElementById('ring-sizer-modal');
  if (existingModal) {
    existingModal.remove();
  }

  // Récupérer les textes configurables
  const confirmationTitle = blockSettings.confirmation_title || 'MERCI {civility} {lastname}';
  const confirmationMessage = blockSettings.confirmation_message || 'Votre demande de baguier gratuit a bien été prise en compte.';
  const confirmationDeliveryInfo = blockSettings.confirmation_delivery_info || '';
  const confirmationEmailInfo = blockSettings.confirmation_email_info || '';
  const confirmationCloseButton = blockSettings.confirmation_close_button || 'FERMER';

  // Remplacer les variables dans le titre
  const personalizedTitle = confirmationTitle
    .replace('{civility}', civilite)
    .replace('{lastname}', nom.toUpperCase());

  // Créer la page de confirmation
  const confirmationModal = document.createElement('div');
  confirmationModal.id = 'ring-sizer-confirmation';
  confirmationModal.innerHTML = `
    <div class="ring-sizer-modal-backdrop" style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(0,0,0,0.7); z-index: 99999; display: flex; align-items: center; justify-content: center; padding: 20px;">
      <div class="ring-sizer-modal-content" style="background: white; width: 90%; max-width: 500px; position: relative; box-shadow: 0 4px 20px rgba(0,0,0,0.3); text-align: center;">
        <button onclick="closeConfirmationPage()" style="position: absolute; top: 15px; right: 15px; background: none; border: none; font-size: 24px; cursor: pointer; color: #666; padding: 0; width: 30px; height: 30px;">&times;</button>
        
        <div style="padding: 50px 40px;">
          <h2 style="font-family: 'Oswald', sans-serif !important; font-size: 24px !important; font-weight: normal !important; margin: 0 0 30px 0; color: #333; letter-spacing: 1px; text-transform: uppercase;">
            ${personalizedTitle}
          </h2>
          
          <div id="confirmation-message" style="font-size: 16px; line-height: 1.6; color: #333; margin: 0 0 30px 0; font-family: 'EB Garamond', Garamond, serif;">
          </div>
          <style>
            #confirmation-message p {
              margin: 0 0 1.35em 0;
            }
            #confirmation-message p:last-child {
              margin-bottom: 0;
            }
          </style>
          
          <div id="confirmation-delivery" style="font-size: 14px; line-height: 1.6; color: #666; margin: 0 0 15px 0;">
          </div>
          
          <div id="confirmation-email" style="font-size: 14px; line-height: 1.6; color: #666; margin: 0 0 30px 0;">
          </div>
          
          <button onclick="closeConfirmationPage()" style="background: ${blockSettings.button_bg_color || '#000000'}; color: ${blockSettings.button_text_color || 'white'}; border: none; padding: 12px 30px; font-size: 14px; font-weight: normal; letter-spacing: 1px; cursor: pointer; border-radius: 0; font-family: 'Oswald', sans-serif !important; text-transform: uppercase;">
            ${confirmationCloseButton}
          </button>
        </div>
      </div>
    </div>
  `;

  // Ajouter la page de confirmation au body
  document.body.appendChild(confirmationModal);

  const confirmationBackdrop = confirmationModal.querySelector('.ring-sizer-modal-backdrop');
  if (confirmationBackdrop) {
    confirmationBackdrop.addEventListener('click', function(e) {
      if (e.target === confirmationBackdrop) {
        closeConfirmationPage();
      }
    });
  }
  
  // Remplir le contenu rich text
  setTimeout(() => {
    const messageElement = document.getElementById('confirmation-message');
    const deliveryElement = document.getElementById('confirmation-delivery');
    const emailElement = document.getElementById('confirmation-email');
    
    if (messageElement && confirmationMessage && confirmationMessage.trim() !== '') {
      messageElement.innerHTML = confirmationMessage;
    } else if (messageElement) {
      messageElement.style.display = 'none';
    }
    
    if (deliveryElement && confirmationDeliveryInfo && confirmationDeliveryInfo.trim() !== '') {
      deliveryElement.innerHTML = `<span style="color: #333;">${confirmationDeliveryInfo}</span>`;
    } else if (deliveryElement) {
      deliveryElement.style.display = 'none';
    }
    
    if (emailElement && confirmationEmailInfo && confirmationEmailInfo.trim() !== '') {
      emailElement.innerHTML = confirmationEmailInfo;
    } else if (emailElement) {
      emailElement.style.display = 'none';
    }
  }, 100);
}

// Fonction pour fermer la page de confirmation (globale)
window.closeConfirmationPage = function() {
  const confirmationModal = document.getElementById('ring-sizer-confirmation');
  if (confirmationModal) {
    confirmationModal.remove();
    document.body.style.overflow = 'auto';
  }
}

// Exposer les fonctions globalement
window.openRingSizerModal = openRingSizerModal;
window.closeRingSizerModal = closeRingSizerModal;
window.showConfirmationPage = showConfirmationPage;
